import { observer } from 'mobx-react-lite';
import { useMediaQuery } from 'react-responsive';
import { HeaderDesktop } from 'src/components/Header/HeaderDesktop';
import { HeaderMobile } from 'src/components/Header/HeaderMobile';

export const Header = observer(() => {
    const isDesktop = useMediaQuery({
        query: '(min-width: 769px)',
    });

    if (isDesktop) {
        return <HeaderDesktop />;
    }

    return <HeaderMobile />;
});
